import { __awaiter, __generator, __values } from "tslib";
function decorateElement(element, attributes) {
    if (!attributes) {
        return;
    }
    for (var attr in attributes) {
        if (attributes.hasOwnProperty(attr)) {
            // this can be any attributes
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ;
            element[attr] = attributes[attr];
        }
    }
}
function loadScriptUrl(leaf, trustedTypePolicy) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var scriptElement = document.createElement('script');
                    if (trustedTypePolicy === null || trustedTypePolicy === void 0 ? void 0 : trustedTypePolicy.createScriptURL) {
                        scriptElement.src = trustedTypePolicy.createScriptURL(leaf.content);
                    }
                    else {
                        scriptElement.src = leaf.content;
                    }
                    scriptElement.onload = function () {
                        resolve();
                    };
                    scriptElement.onerror = function () {
                        reject(new Error("Dynamically loading script " + leaf.content + " failed"));
                    };
                    decorateElement(scriptElement, leaf.attributes);
                    document.body.appendChild(scriptElement);
                })];
        });
    });
}
function loadScript(leaf) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve) {
                    var scriptElement = document.createElement('script');
                    var inlineScript = document.createTextNode(leaf.content);
                    scriptElement.appendChild(inlineScript);
                    decorateElement(scriptElement, leaf.attributes);
                    document.body.appendChild(scriptElement);
                    resolve();
                })];
        });
    });
}
function loadStyleUrl(leaf) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var linkElement = document.createElement('link');
                    linkElement.rel = 'stylesheet';
                    linkElement.type = 'text/css';
                    linkElement.href = leaf.content;
                    linkElement.onload = function () {
                        resolve();
                    };
                    linkElement.onerror = function () {
                        reject(new Error("Dynamically loading style " + leaf.content + " failed"));
                    };
                    decorateElement(linkElement, leaf.attributes);
                    document.head.appendChild(linkElement);
                })];
        });
    });
}
function loadStyle(leaf) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // @ts-ignore TODO: TS Bug, remove once upgrade
            return [2 /*return*/, new Promise(function (resolve) {
                    var linkElement = document.createElement('link');
                    linkElement.rel = 'stylesheet';
                    linkElement.type = 'text/css';
                    var inlineStyle = document.createTextNode(leaf.content);
                    linkElement.appendChild(inlineStyle);
                    decorateElement(linkElement, leaf.attributes);
                    document.head.appendChild(linkElement);
                    resolve();
                })];
        });
    });
}
export function dynamicLoader(node, trustedTypePolicy) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, err_1, _b, _c, script, e_1_1, err_2;
        var e_1, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _a = node.type;
                    switch (_a) {
                        case 'parallel': return [3 /*break*/, 1];
                        case 'sequential': return [3 /*break*/, 5];
                        case 'scriptUrl': return [3 /*break*/, 16];
                        case 'script': return [3 /*break*/, 18];
                        case 'styleUrl': return [3 /*break*/, 20];
                        case 'style': return [3 /*break*/, 22];
                    }
                    return [3 /*break*/, 24];
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(node.children.map(function (n) {
                            return dynamicLoader(n, trustedTypePolicy);
                        }))];
                case 2:
                    _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _e.sent();
                    if (node.optional) {
                        console.log('Dynamic loading of optional script failed', err_1);
                    }
                    else {
                        throw err_1;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    _e.trys.push([5, 14, , 15]);
                    _e.label = 6;
                case 6:
                    _e.trys.push([6, 11, 12, 13]);
                    _b = __values(node.children), _c = _b.next();
                    _e.label = 7;
                case 7:
                    if (!!_c.done) return [3 /*break*/, 10];
                    script = _c.value;
                    return [4 /*yield*/, dynamicLoader(script, trustedTypePolicy)];
                case 8:
                    _e.sent();
                    _e.label = 9;
                case 9:
                    _c = _b.next();
                    return [3 /*break*/, 7];
                case 10: return [3 /*break*/, 13];
                case 11:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 13];
                case 12:
                    try {
                        if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 13: return [3 /*break*/, 15];
                case 14:
                    err_2 = _e.sent();
                    if (node.optional) {
                        console.log('Dynamic loading of optional script failed', err_2);
                    }
                    else {
                        throw err_2;
                    }
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
                case 16: return [4 /*yield*/, loadScriptUrl(node, trustedTypePolicy)];
                case 17:
                    _e.sent();
                    return [2 /*return*/];
                case 18: return [4 /*yield*/, loadScript(node)];
                case 19:
                    _e.sent();
                    return [2 /*return*/];
                case 20: return [4 /*yield*/, loadStyleUrl(node)];
                case 21:
                    _e.sent();
                    return [2 /*return*/];
                case 22: return [4 /*yield*/, loadStyle(node)];
                case 23:
                    _e.sent();
                    return [2 /*return*/];
                case 24: throw new Error("Invalid script loader object " + JSON.stringify(node));
            }
        });
    });
}
